import React, { useState } from 'react';
import { Card, Tab } from 'react-bootstrap';

import Tabs from '../../../app/components/Tabs';
import YesNoModal from '../../../app/components/YesNoModal';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { HealthcareFacilityList } from '../../components/HealthcareFacility/HealthcareFacilityList';

type CheckboxType = 'online' | 'main';

interface ConfirmDialogState {
  show: boolean;
  type: CheckboxType;
  facilityId: string;
  facilityName: string;
}

export const HealthcareFacilitiesView: React.FC = () => {
  const spd = useSpdCore();
  const [confirmDialog, setConfirmDialog] = useState<ConfirmDialogState>();

  const handleSetAsOnline = (facilityId: string, facilityName: string) => {
    setConfirmDialog({
      show: true,
      type: 'online',
      facilityId,
      facilityName,
    });
  };

  const handleSetAsMain = (facilityId: string, facilityName: string) => {
    setConfirmDialog({
      show: true,
      type: 'main',
      facilityId,
      facilityName,
    });
  };

  const getDataWithCallbacks = async (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
  ) => {
    return spd.healthCareFacilities.getAllByPortion(
      pageSize,
      pageNumber,
      orderBy,
      orderDirection,
      filterText,
      handleSetAsMain,
      handleSetAsOnline,
    );
  };

  const handleConfirm = async () => {
    if (!confirmDialog) {
      return;
    }

    try {
      await spd.healthCareFacilities.setFlag(confirmDialog.facilityId, {
        [confirmDialog.type]: true,
      });
    } catch (error) {
      console.error('Error updating facility:', error);
    }
    setConfirmDialog(undefined);
  };

  const handleCancel = () => {
    setConfirmDialog(undefined);
  };

  return (
    <>
      <Card>
        <Tabs
          defaultActiveKey="search"
          id="healthcareFacility"
          className="mb-3"
        >
          <Tab eventKey="search" title="Placówki" className="m-3">
            <HealthcareFacilityList
              getData={getDataWithCallbacks}
              getCount={spd.healthCareFacilities.getAllCount}
              isHistorical={false}
            />
          </Tab>
          <Tab eventKey="history" title="Placówki historyczne" className="m-3">
            <HealthcareFacilityList
              getData={spd.healthCareFacilities.getAllHistoricalByPortion}
              getCount={spd.healthCareFacilities.getAllHistoricalCount}
              isHistorical={true}
            />
          </Tab>
        </Tabs>
      </Card>
      <YesNoModal
        header={`Zmiana placówki ${
          confirmDialog?.type === 'online' ? 'online' : 'głównej'
        }`}
        show={confirmDialog?.show || false}
        onOk={handleConfirm}
        onHide={handleCancel}
      >
        <p>
          {confirmDialog?.type === 'online'
            ? `Czy ustawić placówkę "${confirmDialog?.facilityName}" dla badań online z portalu badanego?`
            : `Czy ustawić placówkę "${confirmDialog?.facilityName}" jako główną?`}
        </p>
      </YesNoModal>
    </>
  );
};
